var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area-division"},[_c('title-one',{attrs:{"title":_vm.title || '',"ps-txt":_vm.psTxt}}),_c('div',{staticClass:"rank-one left"},_vm._l((_vm.list),function(item,index){return _c('area-item',{key:index,attrs:{"item":_vm._f("changeArea")(item)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }